/**
 * Copyright IBM Corp. 2016, 2018
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
// Alias for import paths for build tools that rely on this
import { AccordionItem } from '../Accordion';
export default AccordionItem;